import fetch from 'isomorphic-fetch'
import { URL } from '../constants/api'

function getDefaultHeaders() {
  return {
  'Content-Type': 'application/json'
  }
}

const request = function(url, method = 'GET') {
  return new Promise(function(resolve, reject) {
    fetch(url, {
      method: method, headers: getDefaultHeaders()
    }).then(function(response) {
      response.json().then(function(data){
        if (response.ok)
          resolve(data)
        else
          reject(data)
      })
    }).catch(function(err){
      reject([err.toString()])
    })
  })
}

export default {
  fetchVentures(pl) {
    var ENDPOINT = URL + 'ventures' + '?landing=true' + '&pl=' + pl
    return request(ENDPOINT, 'GET')
  }
}


// WEBPACK FOOTER //
// ./src/api/ventures.js